import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles.css';

if (window.location.hostname.endsWith('.nightshade-mob.pages.dev')
  || window.location.hostname === 'nightshade-mob.pages.dev') {
  window.location.replace(
    `https://mob.nightshade.gameonsolutions.uk${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// Register the service worker for PWA install + offline shell. Not blocking;
// failure here just degrades to a regular SPA.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      console.warn('[mob] service worker registration failed', e);
    });
  });
}
